
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

import { cssClass } from '../../style';

export namespace PermissionsLockUnlockStyles {
  const permissionsLockUnlockCssPrefix = 'PermissionsLockUnlock';
  export const permissionsLockUnlockHeight = 24;
  export const LockedIcon = 'lock_14px-small.svg';
  export const UnlockedIcon = 'lock_unlocked_14px-small.svg';

  export const ContentContainer = cssClass(permissionsLockUnlockCssPrefix, 'content-container', {
    float: 'left',
    height: `${permissionsLockUnlockHeight}px`,
  });

  export const Label = cssClass(permissionsLockUnlockCssPrefix, 'label', {
    display: 'inline-block',
    lineHeight: `${permissionsLockUnlockHeight}px`,
    verticalAlign: 'middle',
  });

  export const EditButton = cssClass(permissionsLockUnlockCssPrefix, 'edit-button', {
    marginLeft: `${CommonStyles.Sizes.DefaultSpace}px`,
    verticalAlign: 'middle',
  });

  export const TextLink = cssClass(permissionsLockUnlockCssPrefix, 'text-link', {
    display: 'inline-block',
    marginLeft: `${CommonStyles.Sizes.DefaultSpace}px`,
    verticalAlign: 'middle',
  });

  export const ProgressBar = cssClass(permissionsLockUnlockCssPrefix, 'progress-bar', {
    display: 'inline-block',
  });

  export const StatusIcon = cssClass(permissionsLockUnlockCssPrefix, 'status-icon', {
    marginRight: '8px',
    verticalAlign: 'text-bottom',
  });

}
